import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function batch<T>(array: T[], size: number): T[][] {
  const batched: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    batched.push(array.slice(i, i + size));
  }
  return batched;
}

export function kebabToTitleCase(kebabCase: string): string {
  return kebabCase
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
